// pages/Shop.jsx
import React from "react";
import Navigation from "../components/Common/header/Navigation";
import ProductSection from "../components/ProductSection";
import Footer from "../components/Common/footer/Footer";
import "../styles/Pages.css";

const Shop = () => {
    return (
        <div className="page-shell shop-page">
            <Navigation />

            {/* ── Subtle shop hero ── */}
            <section className="shop-hero">
                <div className="container" style={{ position: "relative", zIndex: 1 }}>
                    <span className="page-hero-eyebrow">Bundle Madness</span>
                    <h1 style={{
                        fontFamily: "var(--font-display)",
                        fontSize: "clamp(1.8rem, 4vw, 3rem)",
                        fontWeight: 400,
                        letterSpacing: "5px",
                        textTransform: "uppercase",
                        color: "var(--text-primary)",
                        margin: "10px 0 12px",
                    }}>
                        The Collection
                    </h1>
                    <div style={{ width: 48, height: 1, background: "var(--gold)", opacity: 0.5, margin: "0 auto" }} />
                </div>
            </section>

            <ProductSection />
            <Footer />
        </div>
    );
};

export default Shop;